export default "__VITE_ASSET__CZLQ87Zf__"